import type { ReactElement } from 'react'
import { useState } from 'react'
import cc from 'classcat'

import { useTranslate } from '../../utils/translate'
import Lightbox from './Lightbox'
import Portal from './Portal'

const GARAN_INFORMATION_URL = 'https://europa.eu/youreurope/commercial-guarantee-durability/index.htm'

type Props = Readonly<{
  garanLabel: Core.ProductAttachment
  nestedGaranLabel?: Core.ProductAttachment | null
}>

export default function GaranLabel({ garanLabel, nestedGaranLabel }: Props): ReactElement {
  const t = useTranslate('shop')
  const [isOpen, setIsOpen] = useState(false)

  const isPdf = garanLabel.dataUri.split('?')[0].toLowerCase().endsWith('.pdf')

  return (
    <>
      <a
        href={garanLabel.dataUri}
        target="_blank"
        rel="noreferrer"
        className={cc(['garan-label-link', { 'garan-label-nested': nestedGaranLabel }])}
        onClick={(event) => {
          if (isPdf) return
          event.preventDefault()
          setIsOpen(true)
        }}
      >
        {nestedGaranLabel ? (
          <img src={nestedGaranLabel.dataUri} alt={nestedGaranLabel.label} loading="lazy" />
        ) : (
          garanLabel.label
        )}
      </a>
      {!isPdf && (
        <Portal>
          <Lightbox show={isOpen} closeOnBackdropClick onClose={() => setIsOpen(false)}>
            <img className="garan-label-image" src={garanLabel.dataUri} alt={garanLabel.label} />
            <a className="garan-label-information-link" href={GARAN_INFORMATION_URL} target="_blank" rel="noreferrer">
              {t('components.productComponent.garanLabelInformationLink')}
            </a>
          </Lightbox>
        </Portal>
      )}
    </>
  )
}
